import { LinkIcon } from 'lucide-react';

import { useIntegrations } from '@/entities/integrations';
import { useHasPermission } from '@/entities/profile';
import { SidebarDynamicMenuItem } from '@/shared/lib';

/**
 * Пункты динамического подменю активных интеграций под пунктом «Интеграции».
 *
 * Каждая активная интеграция отображается отдельным пунктом меню,
 * ведущим на /integrations/{code}.
 *
 * Сведения об интеграциях открыты только под своим разрешением: без него запрос не уходит вовсе,
 * иначе отказ сервера всплывал бы сообщением об ошибке на каждой загрузке любой страницы — подменю
 * строится вместе с навигацией, а не только когда пункт «Интеграции» показан.
 */
export const useIntegrationsMenuItems = (): SidebarDynamicMenuItem[] => {
  const canViewIntegrations = useHasPermission('VIEW_INTEGRATION_INFO');
  const { data } = useIntegrations({ isActive: true, limit: 100 }, { enabled: canViewIntegrations });

  return (data?.items ?? []).map((integration) => ({
    key: integration.code,
    path: `/integrations/${integration.code}`,
    icon: <LinkIcon size={16} strokeWidth={1.25} className="text-muted-foreground" />,
    label: integration.name,
  }));
};
